import { AfterViewInit, Component, ElementRef, inject, Input, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '../../../components/icon/icon.component';
import { TypoComponent } from '../../../components/typo/typo.component';
import { TypoColor } from '../../../components/typo/types/color.type';
import { TypoName } from '../../../components/typo/types/name.type';
import { Weight } from '../../../components/typo/types/weight.enum';
import { IconColor } from '../../../components/icon/types/icon-color.types';
import { Style } from './types/style.type';
import { Size } from './types/size.type';
import { Type } from './types/button-type.type';
import { constructTypoColor, constructIconColor, constructIconSize } from './helpers/button.helper';
import { ThemeService } from '../../../../core/services/theme.service';
import { TranslateModule } from '@ngx-translate/core';
import { Observable } from 'rxjs';

@Component({
    selector: 'berry-button',
    standalone: true,
    imports: [CommonModule, TypoComponent, IconComponent, TranslateModule],
    templateUrl: './button.component.html',
    styleUrl: './button.component.scss',
    providers: []
})
export class ButtonComponent implements AfterViewInit {
    @Input() label: string = 'اضغط هنا';
    @Input() style: Style = 'filled';
    @Input() type: Type = 'primary';
    @Input() size: Size = 'medium'
    @Input() leftIcon: string = '';
    @Input() withBorder: boolean = true;
    @Input() rightIcon: string = '';
    @Input() rightIconColor!: IconColor;
    @Input() color: TypoColor = 'primary';
    @Input() disabled: boolean = false;
    @Input() typoWeight: Weight = Weight._500;
    @Input() typoName: TypoName = 'body2';
    @Input() width!: number;
    @Input() bottonType: 'button' | 'reset' | 'submit' = 'submit';
    @Input({ required: true, alias: 'data-automation-id' }) dataAutomationId !: string;
    @ViewChild('button') buttonElement!: ElementRef<HTMLButtonElement>;
    @Input() isOutlinedStartIcon: boolean = true;
    @Input() isOutlinedRightIcon: boolean = true;
    themeService = inject(ThemeService)
    isDarkMode$: Observable<boolean> = this.themeService.isDarkMode
    constructor() {}
    ngAfterViewInit(): void {
        this.removeDataAutomationIdFromParent();
    }

    ngOnInit() {

        if (!this.dataAutomationId) {
            throw (new Error("Please add data-automation-id"));
        }

    }

    removeDataAutomationIdFromParent() {
       
        const parentElement = this.buttonElement.nativeElement.parentElement;
        if (parentElement && this.dataAutomationId) {
          parentElement.removeAttribute('data-automation-id');
          
        }
      }

    public get className(): string {
        return `btn-${this.type}__${this.style} ${this.size} ${!this.withBorder ? 'border-0-primary' : ''}`
    }

    public get typoColor(): TypoColor {
        return constructTypoColor(this.type, this.style)
    }

    public get iconColor(): IconColor {
        if (!!this.rightIconColor)
            return this.rightIconColor;
            else
        return constructIconColor(this.type, this.style);
    }

    public get iconSize(): number {
        return constructIconSize(this.size);
    }

    public constructTypoName() {
        switch (this.size) {
            case 'small':
                this.typoName = 'body2'
                this.typoWeight = Weight._500
                break;
            case 'medium':
                this.typoName = 'body1'
                this.typoWeight = Weight._500
                break;
            case 'large':
                this.typoName = 'body1'
                this.typoWeight = Weight._700
                break;

        }
    }
    deactivate(ele:HTMLButtonElement){
        ele.blur()
    }
}
